import React from 'react';
export var SidebarContext = React.createContext({
    addSidebar: function () { },
    removeSidebar: function () { },
});
//# sourceMappingURL=sidebar-context.js.map